export default "<%- JSON.stringify(params, null, 4) -%>\n"